import './App.css';
import constants from './constants';
import ProductList from './components/ProductList';

const App = () => {
    return (
        <div className='App'>
            <header className='App-header'>
                <p>Sneakers World Shopping</p>
            </header>
            <ProductList />
            <footer className='App-footer'>
                <a
                    href={`mailto:${constants.email}?subject=${constants.subject}&body=${constants.body}`}
                >
                    Contact Us
                </a>
            </footer>
        </div>
    );
};

export default App;
